import styled, {ThemeProps, keyframes} from 'styled-components';
import {
  CenteredSpaceWrap,
  SmallSectionHeader,
  CenteredDivWrap,
} from '../../../../CommonStyleUtils/dwebCommon.styles';
import Image from '@stencil/image';

const placeHolderShimmer = keyframes`
  0% {
    background-position: -46.8rem 0;
  }

  100% {
    background-position: 46.8rem 0;
  }
`;

export const contentLoader = styled.div`
  background: ${props => props.theme.colors.goBrandBlue.medium};
  background-image: linear-gradient(to right, #d1e5ff 0%, #e2efff 20%, #d1e5ff 40%, #d1e5ff 100%);
  background-size: 50rem 3.8rem;
  animation-name: ${placeHolderShimmer};
  animation-fill-mode: forwards;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  border-radius: ${props => props.theme.misc.borderRadius.small};
  margin-bottom: ${props => props.theme.spacing.small};
`;

export const CaptivateBannerGalleryLoaderContainer = styled.div(
  props => `
    display:flex;
    width:50%;
    margin-right:${props.theme.spacing.large} ;

  `,
);

export const CaptivateHotelNameLoader = styled(contentLoader)(
  props => `
    display:flex;
    width:80%;
    height:1.5rem;
    margin-bottom:${props.theme.spacing.base};
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  `,
);

export const CaptivateHotelLocationLoader = styled(contentLoader)(
  props => `
    display:flex;
    width:50%;
    height:1.5rem;
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  `,
);

export const CaptivateAllImageModalContainer = styled.section(
  props => `
    width:100%;
    background:${props.theme.colors.downriver.base};
  `,
);

export const CaptivateAllImageModalInnerWrap = styled.section(
  props => `
    display: flex;
    max-width: 120rem;
    max-height: 80rem;
    margin: 0 auto;
    justify-content:space-between;
  `,
);

export const CaptivateLeftContainer = styled.div(
  props => `

    position:relative;
    // margin-top: ${props.theme.spacing.custom(36)};
    overflow: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  `,
);

export const CaptivateHeaderText = styled(SmallSectionHeader)(
  props => `
    color:${props.theme.colors.goWhite.base};
    text-transform: capitalize;
  `,
);

export const CaptivateRightContainer = styled.div(
  props => `
    background:${props.theme.colors.goWhite.base};
    width: 30%;
    overflow: scroll;
  `,
);

export const SmallImageRightDiv = styled.div(
  props => `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width:100%;
  `,
);

export const CaptivateRightTopWrap = styled.div(
  props => `
    box-shadow: 0 5px 6px -6px ${props.theme.colors.downriver.light};
    padding: ${props.theme.spacing.custom(16)};
    width:100%;
    `,
);

export const CaptivateHeaderWrap = styled(CenteredSpaceWrap)(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
  `,
);

export const CategoryOverviewBlock = styled.div(
  props => `
    margin-bottom: ${props.theme.spacing.custom(12)};
  `,
);

export const ViewMorePills = styled.div(
  props => `
    display:flex;
    align-items: center;
    color:${props.theme.colors.goWhite.base};
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
    padding: ${props.theme.spacing.small};
    background:${props.theme.colors.downriver.medium};
    border-radius:${props.theme.misc.borderRadius.custom(15.5)};
  `,
);

export const ViewAllPills = styled.div(
  props => `
    color:${props.theme.colors.goWhite.base};
    font-weight: 600;
    font-size: ${props.theme.font.custom(14)};
  `,
);

export const RadioButtonTabOuterWrapper = styled.div(
  props => `
  display:flex;
    padding: ${props.theme.spacing.xsmall};
    margin-top:  ${props.theme.spacing.custom(12)};
    border: .1rem solid ${props.theme.colors.ash.dark};
    border-radius:${props.theme.misc.borderRadius.custom(26.5)};
      `,
);

export const RadioButtonTabInnerWrapper = styled(contentLoader)(
  props => `
    width: 50%;
    cursor:pointer;
    margin-bottom:0;
    border-radius:${props.theme.misc.borderRadius.custom(46)};
    height:4.5rem;
    `,
);

export const TotalNoGuestText = styled.div(
  props => `
  color:${props.theme.colors.downriver.light};
  font-size: ${props.theme.font.custom(10)};
  &:hover {
    color:${props.theme.colors.goWhite.medium};
    }
    `,
);

export const RadioButtonTabSelected = styled.input(
  props => `
      position: absolute;
      opacity:0;
      & + label {
      display:flex;
      align-items:center;
      justify-content:center;
      padding: ${props.theme.spacing.custom(12)} ${props.theme.spacing.base};
      border-radius:${props.theme.misc.borderRadius.custom(46)};
        font-size: ${props.theme.font.custom(14)};
      font-weight: 600;
      color:${props.theme.colors.ash.base};
      // width:50%;
      height:4.5rem;
      &:hover {
        background-color:${props.theme.colors.goBrandBlue.base};
        color:${props.theme.colors.goWhite.base};
        cursor:pointer;
        }
      &.active {
          background-color:${props.theme.colors.goBrandBlue.base};
          color:${props.theme.colors.goWhite.base};
          cursor:pointer;
          }
      }
      &:checked + label {
      background: ${props.theme.colors.goBrandBlue.base};
      color:${props.theme.colors.goWhite.base};
      }
      &:checked + label >svg{
        fill:${props.theme.colors.goWhite.base};
        }
      &:checked + label>div>div{
        color:${props.theme.colors.goWhite.medium};
        }
    `,
);

export const CaptivateImageCategoriesContainer = styled.div(
  props => `
    padding: ${props.theme.spacing.custom(16)};
    `,
);

export const CaptivateImageCategoriesCard = styled.div(
  props => `
    cursor:pointer;
    padding: ${props.theme.spacing.custom(16)};
    border: .1rem solid ${props.theme.colors.ash.dark};
    border-radius:${props.theme.misc.borderRadius.xlarge};
    margin-bottom:${props.theme.spacing.custom(12)};
    &:last-child{
      margin-bottom:0;
    }
    >div>div{
      width:100%;
    }
    &.active{
      border: .2rem solid ${props.theme.colors.goBrandBlue.base};
    }
    `,
);

export const CaptivateImageCategoryLabel = styled(contentLoader)(
  props => `
  width:50%;
  border-radius:${props.theme.misc.borderRadius.xlarge};
  height:1.5rem;
    `,
);

export const CaptivateTotalImages = styled(contentLoader)(
  props => `
  width:70%;
  border-radius:${props.theme.misc.borderRadius.xlarge};
  height:1.5rem;
    `,
);

export const CaptivateCategoryImage = styled(contentLoader)(
  props => `
    width:5rem;
    height:5rem;
    border-radius:${props.theme.misc.borderRadius.base};
    `,
);

export const CaptivateCategoryAllImageOne = styled(contentLoader)(
  props => `
    width:3.2rem;
    height:3.2rem;
    border-radius:${props.theme.misc.borderRadius.base};

    `,
);

export const CaptivateCategoryAllImageTwo = styled(Image)(
  props => `
    width:2rem;
    height:2rem;
    border-radius:${props.theme.misc.borderRadius.base};
    `,
);

export const CaptivateCategoryAllImagThree = styled(Image)(
  props => `
    display:flex;
    width:2.6rem;
    height:2.6rem;
    border-radius:${props.theme.misc.borderRadius.base};
    margin:  ${props.theme.spacing.custom(7)} auto 0;
    `,
);

export const LeftHeaderLoader = styled(contentLoader)(
  props => `
    width:10%;
    height:3.2rem;
    border-radius:${props.theme.misc.borderRadius.custom(30)};
    margin-top:${props.theme.spacing.base};
    `,
);

export const LeftLoaderMainWrapper = styled.div(
  props => `
    width:${props.width || '70%'};
    flex-direction:column;
    margin-right:${props.theme.spacing.xlarge};

    `,
);

export const LeftCubeLoaderMainWrapper = styled(CenteredDivWrap)(
  props => `
    width:100%;
    position: absolute;
    top:0;
    height: 100%;
    background:${props.theme.colors.downriver.base};
    opacity: 0.2;
    margin-right:${props.theme.spacing.xlarge};

    `,
);

export const FirstBlockWrapper = styled.div(
  props => `
    width:100%;
    display:flex;
    flex-direction:column;
    align-items:flex-end;
    `,
);

export const FirstImageLoaderLoader = styled(contentLoader)(
  props => `
    width:98%;
    height:21.2rem;
    border-radius:${props.theme.misc.borderRadius.custom(10)};
    margin:${props.theme.spacing.base} 0 0 0;
    `,
);

export const SecondImageLoaderLoader = styled(contentLoader)(
  props => `
    width:98%;
    height:43.9rem;
    border-radius:${props.theme.misc.borderRadius.custom(10)};
    margin:${props.theme.spacing.base} 0 0 0;
    `,
);

export const HeaderBlockDiv = styled.div(
  props => `
    width:100%;
    display:flex;
    justify-content:space-between;
    `,
);

export const HeaderLeftBlockLoader = styled(contentLoader)(
  props => `
    width:25%;
    height:3.2rem;
    border-radius:${props.theme.misc.borderRadius.custom(20)};
    margin-top:${props.theme.spacing.base};
    margin-bottom:0px;
    margin-right:${props.theme.spacing.large};
    `,
);

export const CubeLoaderImage = styled(Image)(
  props => `
    display:flex;
    width:20.6rem;
    height:20.6rem;
    align-items:center;
    justify-content:center;
    margin: 0 auto;

    `,
);

export const CubeLoaderWrap = styled(CenteredDivWrap)(
  props => `
    width:100%;
    height: 40.9rem;
    background:${props.theme.colors.downriver.base};
    `,
);
